<div nxRow>
  <div nxCol="12">
    <h2 class="nx-margin-0 nx-margin-bottom-3xs">Coverage</h2>
    <p nxCopytext="small"><i>{{ 'GLOBAL.INFORM.REQUIRED_FIELDS' | translate }}</i></p>
  </div>
</div>

<form [formGroup]="coverageFmGroup">

  <div nxRow class="nx-margin-top-2m">
    <div nxCol="12">
      <app-vehicle-details *ngIf="vehicleUselov" (onChangedVehicle)="onChangedVehicle($event)" (calculatePremium)="calculatePremium($event, {})" [coverageFmGroup]="coverageFmGroup" [vehicleUselov]="vehicleUselov" />
    </div>
  </div>

  <app-type-of-coverage *ngIf="coverList" 
    (calculatePremium)="calculatePremium($event, {})" (coverFormChanged)="onCoverFormChanged($event)"
    [coverageFmGroup]="coverageFmGroup" [coverListLov]="coverList" [partnerInfo]="partnerInfo" />

  <div nxRow class="nx-margin-top-50 nx-margin-bottom-3xl">
    <div nxCol="12" class="button-container-general">
      <button type="button" nxButton="secondary" (click)="goBack()">
        {{ 'GLOBAL.ACTION.BACK' | translate }}
      </button>
      @if (this.isSaved && this.isSaved.cnoteStatus && this.isSaved.cnoteStatus=== 'SAVED') {
        <button type="button" nxButton="secondary" (click)="cancelDraft()" [disabled]="!hasCoverNoteAccess()">
          {{ 'GLOBAL.ACTION.CANCEL_DRAFT' | translate }}
        </button>
      }
      <button *ngIf="!hideSaveDraftBtn" type="button" nxButton="secondary" [disabled]="!hasCoverNoteAccess()" (click)="saveAsDraft()">
        {{ 'GLOBAL.ACTION.SAVE_DRAFT' | translate }}
      </button>
      <button type="button" nxButton="primary" (click)="next()" [disabled]="!isNext(currentTypeOfCoverage$ | async)">
        {{ 'GLOBAL.ACTION.NEXT' | translate }}
      </button>
    </div>
  </div>

</form>
